import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import companyReducer from './companySlice';
import campaignReducer from './campaignSlice';
import adminReducer from './adminSlice';
import subscriptionReducer from './subscriptionSlice';
import claimReducer from './claimSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    company: companyReducer,
    campaign: campaignReducer,
    admin: adminReducer,
    subscription: subscriptionReducer,
    claim: claimReducer,
  },
});

export default store;
